import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/_nextgen/applications/MyLexus/components/InfoCardGroup")
);
 
const EditConfig = {
  emptyLabel: 'Info Card Group',
  isEmpty: function(props) {
    return !props || !props.title || props.title.trim().length < 1;
  }
};

const Render = (props) => {
  return <Component {...props} />;
}

export default withAemIntegration("lexus/components/content/info-card-group")(
  Render,
  EditConfig
);
